import { Button } from "../../../../ui/index.ts";
import type { ProjectWithAllocationsDerived } from "../../../../../hooks/time-allocation/use-time-allocation-page.ts";
import { EmployeeAllocationTable } from "../employee-allocation-table/employee-allocation-table.tsx";

import styles from "./project-allocation-panel.module.css";

export type ProjectAllocationToolbarProps = {
  onSaveClick: () => void;
  onDiscardClick: () => void;
};

/** Save / Discard row; rendered in the accordion header toolbar slot when there are unsaved edits. */
export function ProjectAllocationToolbar({
  onSaveClick,
  onDiscardClick,
}: ProjectAllocationToolbarProps) {
  return (
    <div className={styles.toolbarInline} role="toolbar" aria-label="Allocation changes">
      <Button type="button" variant="muted-outline" onClick={onDiscardClick}>
        Discard changes
      </Button>
      <Button type="button" onClick={onSaveClick}>
        Save
      </Button>
    </div>
  );
}

export type ProjectAllocationPanelProps = {
  project: ProjectWithAllocationsDerived;
  setAssignedHours: (projectId: string, employeeId: string, hours: number) => void;
  openViewAllocations: (projectId: string, employeeId: string) => void;
};

/** Table only — scrolls with the page (no inset scroll container). */
export function ProjectAllocationPanel({
  project,
  setAssignedHours,
  openViewAllocations,
}: ProjectAllocationPanelProps) {
  return (
    <div className={styles.panel}>
      <EmployeeAllocationTable
        project={project}
        setAssignedHours={setAssignedHours}
        openViewAllocations={openViewAllocations}
      />
    </div>
  );
}
